import { Flex, Image, Text } from "@chakra-ui/react";

const ReservationCompleted = () => {
    return (
        <Flex
            px="20px"
            w="100%"
            h="100%"
            flexDirection={"column"}
            alignItems="center"
            pt="10.625rem"
        >
            <Image
                w="3.5rem"
                h="3.5rem"
                mb="1rem"
                src="/assets/images/icn_exclaim_circle.svg"
            />
            <Text fontWeight={"semibold"} fontSize="1.375rem" mb="0.75rem">
                버틀러 예약 변경 만료
            </Text>
            <Text
                fontSize={"0.875rem"}
                fontWeight="medium"
                textAlign={"center"}
                w="16.5rem"
                color={"#757575"}
            >
                주문 진행이 예약 추가/변경이 불가능한 상태로 진행되어, 더 이상
                예약 링크를 사용할 수 없어요
            </Text>
        </Flex>
    );
};

export default ReservationCompleted;
